// extracted by mini-css-extract-plugin
export default {"wrapper":"S0Q22zIglI3t_XuCB3xQ"};